import {AccountInfo} from '@azure/msal-browser';
import {createContext} from 'react';


export interface authContextType {
    accounts: AccountInfo[],
    setUserToken: (redirect: string)=> void
}

const AuthContext = createContext<authContextType>({
    accounts: [],
    setUserToken: ()=> undefined
});

export {AuthContext};

